/*
  Behaviour for sections/pf-product.liquid (the general product template).

  Named pf-pdp.js on purpose: assets/pf-product.js belongs to the custom
  machine and ink pages (pf-product-hero and friends). This file once shipped
  under that name and silently replaced theirs, which killed their currency
  toggle, carousel, size toggle and FAQ. Keep the two apart.

  Deliberately a separate asset rather than an inline <script> in the section:
  Liquid parses {{ ... }} inside inline scripts, so a client-side money formatter
  written there had its {{amount}} placeholder evaluated away at render time and
  printed the literal template. Nothing in this file passes through Liquid.

  Prices are NOT formatted here at all. The section serialises each variant's
  price already run through Liquid's `money` filter, which is also what keeps
  Shopify Markets currency rendering correct.
*/
(function () {
  'use strict';

  function init(root) {
    var dataEl = root.querySelector('[data-pf-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var form = root.querySelector('[data-pf-form]');
    var idInput = root.querySelector('[data-pf-variant-id]');
    var priceEl = root.querySelector('[data-pf-price]');
    var compareEl = root.querySelector('[data-pf-compare]');
    var skuEl = root.querySelector('[data-pf-sku]');
    var specSkuEl = root.querySelector('[data-pf-specsku]');
    var cartBtn = root.querySelector('[data-pf-cart]');
    var qtyWrap = root.querySelector('[data-pf-qtywrap]');
    var qtyInput = root.querySelector('[data-pf-qtyinput]');
    var main = root.querySelector('[data-pf-main]');
    var addUrl = root.getAttribute('data-pf-add-url') || '/cart/add';
    var cartUrl = root.getAttribute('data-pf-cart-url') || '/cart';

    // ---- gallery ---------------------------------------------------------
    root.querySelectorAll('[data-pf-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.getAttribute('data-pf-thumb');
        main.alt = btn.getAttribute('data-pf-thumb-alt') || '';
        root.querySelectorAll('[data-pf-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    // ---- tabs ------------------------------------------------------------
    root.querySelectorAll('[data-pf-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.getAttribute('data-pf-tab');
        root.querySelectorAll('[data-pf-tab]').forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-pf-panel]').forEach(function (p) {
          var on = p.getAttribute('data-pf-panel') === name;
          p.hidden = !on;
          p.classList.toggle('is-active', on);
        });
      });
    });

    // ---- variants --------------------------------------------------------
    function selectedOptions() {
      var out = [];
      root.querySelectorAll('[data-pf-optgroup]').forEach(function (g) {
        var active = g.querySelector('.pf-pdp-pill.is-active');
        out.push(active ? active.getAttribute('data-pf-val') : null);
      });
      return out;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function render(v) {
      if (!cartBtn) return;
      if (!v) {
        cartBtn.disabled = true;
        cartBtn.textContent = 'Unavailable';
        if (qtyWrap) qtyWrap.hidden = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        compareEl.hidden = !v.on_sale;
        if (v.on_sale) compareEl.textContent = v.compare_at_price;
      }
      if (skuEl) skuEl.textContent = v.sku ? 'SKU ' + v.sku : '';
      if (specSkuEl) specSkuEl.textContent = v.sku || '—';
      cartBtn.disabled = !v.available;
      cartBtn.textContent = v.available ? 'Add to Cart' : 'Sold out';
      if (qtyWrap) qtyWrap.hidden = !v.available;

      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* older browsers: harmless */ }
      }
    }

    root.querySelectorAll('.pf-pdp-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('[data-pf-optgroup]');
        group.querySelectorAll('.pf-pdp-pill').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var chosen = group.querySelector('[data-pf-optchosen]');
        if (chosen) chosen.textContent = pill.getAttribute('data-pf-val');
        render(findVariant(selectedOptions()));
      });
    });

    // ---- quantity --------------------------------------------------------
    root.querySelectorAll('[data-pf-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(btn.getAttribute('data-pf-qty'), 10);
        var next = (parseInt(qtyInput.value, 10) || 1) + step;
        qtyInput.value = next < 1 ? 1 : next;
      });
    });

    // ---- add to cart -----------------------------------------------------
    // Progressive enhancement: with JS off the form posts to /cart/add as normal.
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var original = 'Add to Cart';
        cartBtn.disabled = true;
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: parseInt(qtyInput.value, 10) || 1 })
        })
          .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.body && res.body.description) || 'Could not add to cart');
            cartBtn.textContent = 'Added to cart ✓';
            return fetch(cartUrl + '.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            if (!cart) return;
            document.querySelectorAll('.cart-products-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          })
          .catch(function (err) {
            cartBtn.textContent = err.message || 'Could not add to cart';
          })
          .then(function () {
            setTimeout(function () {
              cartBtn.textContent = original;
              cartBtn.disabled = false;
            }, 2200);
          });
      });
    }
  }

  function boot() {
    document.querySelectorAll('.pf-pdp').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
